import {types} from './types';

const initialState = {
    list: {
        data: [],
        countPage: 1,
    },
}

export function historyReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_HISTORY_LIST:
            return { ...state, list: action.payload};
        default:
            return state
    }
}